import LandingPageSelectionSlide from "./LandingPageSelectionSlide";

export default LandingPageSelectionSlide;
